/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Firm_Wolf_VerifyInputs */

const en_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm new email address`)
};

const id_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi alamat email baru`)
};

const ms_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahkan alamat e-mel baru`)
};

const ca_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar la nova adreça de correu electrònic`)
};

const cs_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrďte svou novou e-mailovou adresu`)
};

const da_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft ny e-mailadresse`)
};

const de_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue E-Mail-Adresse bestätigen`)
};

const et_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinnitage uus e-posti aadress`)
};

const es_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma el nuevo correo electrónico`)
};

const fr_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l’adresse e-mail`)
};

const hr_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdite novu e-mail adresu`)
};

const it_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma nuovo indirizzo email`)
};

const lv_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināt jauno e-pasta adresi`)
};

const lt_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patvirtinti naują el. pašto adresą`)
};

const hu_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új e-mail cím megerősítése`)
};

const nl_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw e-mailadres bevestigen`)
};

const nb_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreft den nye e-postadressen`)
};

const pl_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź nowy adres e-mail`)
};

const pt_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar novo endereço de e-mail`)
};

const ro_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmă noua adresă de e-mail`)
};

const sk_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdiť novú emailovú adresu`)
};

const sl_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrdite novi e-naslov`)
};

const fi_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista uusi sähköpostiosoite`)
};

const sv_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekräfta ny e-postadress`)
};

const vi_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận địa chỉ email mới`)
};

const tr_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni e-posta adresini onayla`)
};

const el_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιβεβαίωση νέας διεύθυνσης email`)
};

const bg_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потвърди новия имейл адрес`)
};

const ru_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить новый адрес электронной почты`)
};

const sr_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потврдите нову имејл адресу`)
};

const uk_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтвердіть нову адресу електронної пошти`)
};

const ka_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ახალი ელფოსტის დადასტურება`)
};

const hi_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया ईमेल एड्रेस कन्फर्म करें`)
};

const th_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันที่อยู่อีเมลใหม่`)
};

const ko_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 이메일 주소 확인`)
};

const zh_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认新电子邮件地址`)
};

const zh_tw_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認新的電子郵件地址`)
};

const ja_solid_firm_wolf_verify = /** @type {(inputs: Solid_Firm_Wolf_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいメールアドレスを確認`)
};

/**
* | output |
* | --- |
* | "Confirm new email address" |
*
* @param {Solid_Firm_Wolf_VerifyInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const solid_firm_wolf_verify = /** @type {((inputs?: Solid_Firm_Wolf_VerifyInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Firm_Wolf_VerifyInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_solid_firm_wolf_verify(inputs)
	if (locale === "ms") return ms_solid_firm_wolf_verify(inputs)
	if (locale === "ca") return ca_solid_firm_wolf_verify(inputs)
	if (locale === "cs") return cs_solid_firm_wolf_verify(inputs)
	if (locale === "da") return da_solid_firm_wolf_verify(inputs)
	if (locale === "de") return de_solid_firm_wolf_verify(inputs)
	if (locale === "et") return et_solid_firm_wolf_verify(inputs)
	if (locale === "es") return es_solid_firm_wolf_verify(inputs)
	if (locale === "fr") return fr_solid_firm_wolf_verify(inputs)
	if (locale === "hr") return hr_solid_firm_wolf_verify(inputs)
	if (locale === "it") return it_solid_firm_wolf_verify(inputs)
	if (locale === "lv") return lv_solid_firm_wolf_verify(inputs)
	if (locale === "lt") return lt_solid_firm_wolf_verify(inputs)
	if (locale === "hu") return hu_solid_firm_wolf_verify(inputs)
	if (locale === "nl") return nl_solid_firm_wolf_verify(inputs)
	if (locale === "nb") return nb_solid_firm_wolf_verify(inputs)
	if (locale === "pl") return pl_solid_firm_wolf_verify(inputs)
	if (locale === "pt") return pt_solid_firm_wolf_verify(inputs)
	if (locale === "ro") return ro_solid_firm_wolf_verify(inputs)
	if (locale === "sk") return sk_solid_firm_wolf_verify(inputs)
	if (locale === "sl") return sl_solid_firm_wolf_verify(inputs)
	if (locale === "fi") return fi_solid_firm_wolf_verify(inputs)
	if (locale === "sv") return sv_solid_firm_wolf_verify(inputs)
	if (locale === "vi") return vi_solid_firm_wolf_verify(inputs)
	if (locale === "tr") return tr_solid_firm_wolf_verify(inputs)
	if (locale === "el") return el_solid_firm_wolf_verify(inputs)
	if (locale === "bg") return bg_solid_firm_wolf_verify(inputs)
	if (locale === "ru") return ru_solid_firm_wolf_verify(inputs)
	if (locale === "sr") return sr_solid_firm_wolf_verify(inputs)
	if (locale === "uk") return uk_solid_firm_wolf_verify(inputs)
	if (locale === "ka") return ka_solid_firm_wolf_verify(inputs)
	if (locale === "hi") return hi_solid_firm_wolf_verify(inputs)
	if (locale === "th") return th_solid_firm_wolf_verify(inputs)
	if (locale === "ko") return ko_solid_firm_wolf_verify(inputs)
	if (locale === "zh") return zh_solid_firm_wolf_verify(inputs)
	if (locale === "zh-tw") return zh_tw_solid_firm_wolf_verify(inputs)
	if (locale === "ja") return ja_solid_firm_wolf_verify(inputs)
	return en_solid_firm_wolf_verify(inputs)
});